import React from 'react';
import {Wrapper} from './Header.styles';


function Header () {
    return (
        <Wrapper>
            <h1>TODOs App</h1>
        </Wrapper>        
    );
     
}
export default Header;